import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const staffSchedules: RouteRecordRaw = {
  name: 'admin.staffSchedules',
  path: 'staff-schedules',
  component: () => import('pages/StaffSchedules.vue'),
  meta: {
    roles: [Roles.RoomStaff],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
